import type { EnvelopeCaveat } from '~stores/kpi-envelope';

/** The metrics a warning limits, by envelope KPI and warning code. A warning
 * with no entry limits every metric of its envelope. */
const WARNING_METRICS: Record<string, Record<string, readonly string[]>> = {
    'login-activity': {
        partial_login_history: ['monthlyActiveUsers'],
        partial_login_history_period: [
            'activeUsers',
            'logins',
            'sessionsPerUser',
        ],
    },
    'login-retention': { partial_login_history: ['returningUserRate'] },
};

export const notesForMetric = (
    kpi: string,
    metricId: string,
    caveats: readonly EnvelopeCaveat[]
): EnvelopeCaveat[] =>
    caveats.filter(
        (entry) =>
            entry.kind !== 'warning' ||
            (WARNING_METRICS[kpi]?.[entry.code]?.includes(metricId) ?? true)
    );
